import {hasFullAccess} from 'ultra/helpers/auth';
import {isTgID} from "ultra/helpers/telegram";

import Button from '@mui/material/Button';

import UserHistoryLink from '../../../../UserHistoryLink'
import {useGlobalCustomContext} from '../../../../../../../Helpers/context';
import {isYoursAccount} from '../../../../../../../Helpers/user';
import BookDetails from '../../../Components/BookDetails'
import MessageLink from '../../../../MessageLink';
import TextZoomImage from '../../../../TextZoomImage';
import DefaultImage from '../../../../DefaultImage';
import PriceWidget from '../../../../Price';

export default function Template(props) {
    const {values, short} = props;

    const {userState} = useGlobalCustomContext();

    const isDocumentOwner = isYoursAccount(userState, values?.details?.owner);

    const fullAccess = hasFullAccess(userState?.user);
    const noFullAccess = !fullAccess;

    const initByCurrentUser = isYoursAccount(userState, values._init_by);

    if (initByCurrentUser) {
        return <>
            <div className="NotificationTitle">
                <>Ви забронювали </>
                <BookDetails values={values} fullAccess={fullAccess} isDocumentOwner={isDocumentOwner} />
            </div>
            {!short && values?.details?.owner_messenger && <div className="NotificationActions">
                <MessageLink
                    variant="button"
                    size="small"
                    label="Написати власнику"
                    messenger = {values.details.owner_messenger}
                    id={values?._init_by}
                />
            </div>}
        </>
    }

    return <>
        <div className="NotificationTitle">
            {isTgID(values?._init_by) && <>Телеграм аккаунт </>}
            {!isTgID(values?._init_by) && <>Аккаунт </>}
            <UserHistoryLink onlyText={noFullAccess} id={values?._init_by} name={values?._init_by_name} />
            <> забронював </>
            <BookDetails values={values} fullAccess={fullAccess} isDocumentOwner={isDocumentOwner} />
        </div>

        {!short && values?._init_by_messenger && <div className="NotificationActions">

            {values?.deposit && <TextZoomImage
                label={<Button fullWidth variant='outlined' size="small">Депозит <PriceWidget value={values.deposit} /></Button>}
            >
                <DefaultImage image={values?.deposit} width="60" zoom />
            </TextZoomImage>}
            
            <MessageLink
                variant="button"
                size="small"
                label="Написати"
                fullWidth
                messenger = {values._init_by_messenger}
                id={values?._init_by}
            />
        </div>}
    </>
}
